import React from 'react';
import { observer } from 'mobx-react';
import { Position } from '@xyflow/react';
import {
  GhostNodeContainer,
  GhostEntityContent,
  GhostEntityName,
  StyledHandle
} from './GhostEntityNode.styles';
import { EntityIcon } from './CustomEntityNode.styles';
import { HoldingEntitySvg } from '../EntityIcons';
import { EmptyStatePlusIcon } from '../../assets/icons';
import { useStore } from '../../../app/data/root.store';

export const GhostEntityNode = observer(({ data, selected }) => {
  const { uiStore } = useStore();
  const {
    name = 'Add holding entity',
    color = '#D7DEE7',
  } = data;

  return (
    <GhostNodeContainer className={`${selected ? 'selected' : ''}`}>
      <StyledHandle
        type="target"
        position={Position.Top}
        id="top"
      />
      <StyledHandle
        type="source"
        position={Position.Bottom}
        id="bottom"
      />

      {uiStore.isDesktopView ?
        <EntityIcon color={color}>
          <HoldingEntitySvg width={24} height={24} color="#1A1B1D" />
        </EntityIcon> :
        <EmptyStatePlusIcon width={16} height={16} />
      }

      <GhostEntityContent>
        <GhostEntityName title={name}>
          {name}
        </GhostEntityName>
      </GhostEntityContent>
    </GhostNodeContainer>
  );
});